<template>
  <b-modal
    id="edit-pto"
    ref="edit-pto"
    size="sm-size"
    modal-class="break-modal"
    centered
    hide-footer
    hide-header
    @hide="close"
  >
    <div class="modal-head">
      <h2 class="modal-title">
        {{ label.get('edit_time_off_code') }}
      </h2>
    </div>
    <div class="content-wrapper">
      <div class="form-container">
        <div class="input-wrapper">
          <div class="name-holder">
            <span class="heading-title">{{ label.get('time_off_code_name') }}</span>
            <input
                v-model="item.name"
                type="text"
                :placeholder="label.get('time_off_code_name')"
                class="atto-input"
            >
          </div>
          <div class="type-holder">
            <span class="heading-title">{{ label.get('type') }}</span>
            <select-dropdown-component
                v-model="item.type"
                :value="item.type"
                placeholder="Select method"
                :options="paid_options"
                @onOptionSelected="onPaidRulesChanged"
            />
          </div>
        </div>

      </div>
    </div>
    <div class="modal-footer">
      <div class="form-buttons">
        <button
          class="atto-btn cancel"
          @click="close"
        >
          {{ label.get('cancel') }}
        </button>
        <button
          class="atto-btn submit"
          :disabled="disabledSaveButton"
          @click="saveChanges"
        >
          {{ label.get('save_changes') }}
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
    import PtoService from '../services/PtoService';
    import SelectDropdownComponent from "../../../../shared/components/SelectDropdownComponent";
    export default {
        name: "EditPtoComponent",
        components: {
          SelectDropdownComponent
        },
        props: {
            pto: {
                type: Object,
                default: () => {
                    return {};
                }
            }
        },
        data(){
          return{
              disabledSaveButton: false,
              item: Object.assign({}, this.pto),
              paid_options: this.getPtoTypes(),
          }
        },
        mounted(){
            document.body.appendChild(this.$el);
            this.$refs['edit-pto'].show();
        },
        methods: {
          getPtoTypes(){
            return PtoService.getPtoTypes(this.label)
            },
            close(){
                this.$root.$emit('hideEditPto');
            },
            saveChanges(){
                if(this.item.name.trim() === '') {
                    return;
                }

                this.disabledSaveButton = true;

                PtoService.editPto(this.item.id, this.item).then((response) => {
                    this.pto.name = this.item.name;
                    this.pto.type = this.item.type;
                    this.$root.$emit('hideEditPto', this.pto);
                }).catch((error) => {
                    this.disabledSaveButton = false;
                    console.log('Error updating Pto code.');
                })

            },
            onPaidRulesChanged(option){
              this.item.type = option.value;
            }

        }
    }
</script>

